import axios from 'axios'

export default function removeHeader() {
  delete axios.defaults.headers.common.Authorization
}
